import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { PeopleDto } from "../../models/people.model";
@Injectable({
  providedIn: "root",
})
export class DataService {
  private selectedPersonSource = new BehaviorSubject<string | null>(null);
  private currentPageToRedirect = new BehaviorSubject<string | null>(null);
  private TMDetails = new BehaviorSubject<string | null>(null);
  private showHeaderForSPARK = new BehaviorSubject<boolean | false>(false);
  private sparkFromVerify = new BehaviorSubject<boolean | false>(false);
  selectedPerson$ = this.selectedPersonSource.asObservable();
  currentPageToRedirect$ = this.currentPageToRedirect.asObservable();
  TMDetails$ = this.TMDetails.asObservable();
  showHeaderForSPARK$ = this.showHeaderForSPARK.asObservable();
  sparkFromVerify$ = this.showHeaderForSPARK.asObservable();
  setSelectedPerson(person: string) {
    this.selectedPersonSource.next(person);
  }
  setTMDetails(details: string) {
    this.TMDetails.next(details);
  }
  setCurrentPageToRedirect(page: string) {
    this.currentPageToRedirect.next(page);
  }
  setShowHeaderForSPARK(state: boolean) {
    this.showHeaderForSPARK.next(state);
  }
  setSparkFromVerify(state: boolean) {
    this.sparkFromVerify.next(state);
  }
}
